import { Component, OnInit, Input } from '@angular/core';
import { PontoFisico } from '../../comum/modelos/ponto-fisico';
import { PontoFisicoService } from '../../ponto-fisico/ponto-fisico.service';
import { Paginacao } from '../../comum/modelos/paginacao';
import { ProcessoCliente } from '../../comum/modelos/processo-cliente';

@Component({
  selector: 'app-listar-pontos-fisicos-rotina',
  templateUrl: './listar-pontos-fisicos-rotina.component.html',
  styleUrls: ['./listar-pontos-fisicos-rotina.component.css']
})
export class ListarPontosFisicosRotinaComponent implements OnInit {

  @Input() processoCliente: ProcessoCliente;

  pontosFisicos: PontoFisico[];
  public paginacao: Paginacao;
  public filtroPesquisaRazaoSocialBind: string;

  statusCode: number;
  public loading = false;

  constructor(private _pontoFisicoService: PontoFisicoService) {
    this.pontosFisicos = new Array<PontoFisico>();
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    this._pontoFisicoService.obterPontosFisicosProcessoHttp(this.processoCliente)
      .subscribe(pontosFisicos => {
        this.pontosFisicos = pontosFisicos.body;
        this.loading = false;
      });
  }

  pesquisarPorFiltro(filtro: any): void {
    this.filtroPesquisaRazaoSocialBind = filtro.value;
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/listar-pontos-fisicos-rotina/listar-pontos-fisicos-rotina.component.ts